/**
 * External dependencies
 */
import React, { useState } from "react";
import { useDebounce } from "use-debounce";
import { useMediaQuery } from 'react-responsive';

/**
 * Internal dependencies
 */
import { AppLoader } from "./loaders";
import { AppWrapper, FiltersWrapper, ResultsWrapper } from "./wrappers";
import { MultiSelect, SearchInput, TabSelect } from "./filters";
import { InfinitePosts, NewsCard } from "./posts";
import { ErrorMessage, useFilters, useUrlParamState } from "./utils";

/**
 * Configuration
 */
import config from "./config";
const { texts } = config || {};

/**
 * Constants
 */
const SEARCH_DEBOUNCE_DURATION = 1000;


const App = ({ perPage }) => {
	/**
	 * Load filter data
	 */
	const { filters, error } = useFilters();
	const { themes } = filters || {};
	const isIpadPortraitPlus = useMediaQuery({
		query: '(min-width: 900px)'
	});

	/**
	 * Setup filter state
	 */
	const [search, setSearch] = useState("");
	const [debouncedSearch] = useDebounce(search, SEARCH_DEBOUNCE_DURATION);
	const [selectedThemes, setSelectedThemes] = useUrlParamState([], "em_t");
	const [selectedLang, setSelectedLang] = useUrlParamState([], "em_lang");

	/**
	 * Error and loading state
	 */
	if (error) {
		return <ErrorMessage />;
	}
	if (!filters) {
		return <AppLoader numOfFilters={2} numOfPosts={perPage} />;
	}

	return (
		<AppWrapper>
			<FiltersWrapper>
			{isIpadPortraitPlus ? 
				<>
					<SearchInput
						{...texts?.search}
						value={search}
						onChange={(value) => setSearch(value)}
						onClear={() => setSearch("")}
					/>
					<TabSelect
						{...texts?.themes}
						options={themes}
						selected={selectedThemes}
						setSelected={setSelectedThemes}
					/> 
				</>
				:
				<>
					<SearchInput
						{...texts?.search}
						value={search}
						onChange={(value) => setSearch(value)}
						onClear={() => setSearch("")}
					/>
					<MultiSelect
						{...texts?.themes}
						options={themes}
						selected={selectedThemes}
						setSelected={setSelectedThemes}
					/>
				</>
			}
			</FiltersWrapper>
			<ResultsWrapper>
				<InfinitePosts
					filters={{
						search: debouncedSearch,
						themes: selectedThemes,
					}}
					perPage={perPage}
					renderPost={(post) => {
						return <NewsCard key={post.id} {...post} themeData={themes} />;
					}}
				/>
			</ResultsWrapper>
		</AppWrapper>
	);
};

export default App;
